// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__lOUZU","Button":"Card_Button__ZzbXh","one":"Card_one__gheft","two":"Card_two__XdYON"};